import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getStoredNewsletterJourneySession, sendNewsletterJourneyEvent } from "../lib/newsletterJourney";

const EXCLUDED_PREFIXES = ["/dashboard", "/blog/editor"];

function NewsletterJourneyTracker() {
  const location = useLocation();
  const lastTrackedKeyRef = useRef("");

  useEffect(() => {
    const session = getStoredNewsletterJourneySession();
    if (!session) {
      lastTrackedKeyRef.current = "";
      return;
    }

    if (EXCLUDED_PREFIXES.some((prefix) => location.pathname.startsWith(prefix))) {
      return;
    }

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    const trackingKey = `${session.sessionId}:${pagePath}`;
    if (lastTrackedKeyRef.current === trackingKey) {
      return;
    }
    lastTrackedKeyRef.current = trackingKey;

    void sendNewsletterJourneyEvent(
      location.pathname === "/booking" ? "booking_viewed" : "newsletter_page_view",
      {
        pagePath,
        metadata: {
          referrer: typeof document !== "undefined" ? document.referrer || "" : "",
          title: typeof document !== "undefined" ? document.title || "" : "",
        },
      }
    );
  }, [location]);

  return null;
}

export default NewsletterJourneyTracker;
